export default __webpack_public_path__ + "static/media/promo_bg.d7afb40d.png";